export default function testimonials( el ) {
	if ( ! el ) {
		return;
	}
	const slider = el.querySelector( '.b-testimonials-slider' );
	if ( slider ) {
		const carousel = new Flickity( slider, {
			cellAlign: 'center',
			wrapAround: true,
			pageDots: true,
			autoPlay: 6000,
			prevNextButtons: false, // Disable default prev/next buttons
		} );

		/// Function to equalize slide heights
		// Хамгийн өндөр слайдын өндрийг олж, slider болон бүх слайдод тэр өндрийг онооно
		const equalizeSlideHeights = () => {
			const slideItems = slider.querySelectorAll( '.b-testimonials-slide' );
			let maxHeight = 0;

			// Эхлээд бүх слайдын өндрийг reset хийнэ
			slideItems.forEach( ( item ) => {
				item.style.height = '';
				const itemHeight = item.offsetHeight;
				maxHeight = Math.max( maxHeight, itemHeight );
			} );

			// slider-д хамгийн өндөр утсыг онооно
			slider.style.height = maxHeight + 'px';

			// Бүх слайдад slider-ийн өндөр утсыг онооно
			slideItems.forEach( ( item ) => {
				item.style.height = slider.offsetHeight + 'px';
			} );
		};

		equalizeSlideHeights();

		// Equalize heights after Flickity is initialized
		carousel.on( 'ready', equalizeSlideHeights );

		// Re-equalize on window resize
		window.addEventListener( 'resize', () => {
			equalizeSlideHeights();
			carousel.resize(); // Make sure Flickity updates its layout
		} );

		const carouselDot = el.querySelectorAll( '.b-testimonials-slider-dot' );

		if ( carouselDot.length === 0 ) {
			return;
		}

		// Set initial active state
		carouselDot[ 0 ].classList.add( 'is-selected' );

		// Update dots on slide change
		carousel.on( 'select', function( index ) {
			carouselDot.forEach( ( dot ) => dot.classList.remove( 'is-selected' ) );
			carouselDot[ index ].classList.add( 'is-selected' );
		} );

		// Add click handlers to dots
		carouselDot.forEach( ( dot, index ) => {
			dot.addEventListener( 'click', () => {
				carousel.select( index );
			} );
		} );
	}
}
